import React from 'react'
import { Layout } from 'antd'
import classNames from 'classnames'
import { useRouter } from 'next/router'
// import { getUserInfo } from '@/utils'
import LoginModal from '@/components/LoginModal'
import Header from './components/Header'
import Main from './components/Main'
import styles from './PrimaryLayout.module.less'

function PrimaryLayout({ giveawayChannel, children, HeaderComponet = Header }: any) {
  const router = useRouter()
  const pathname = router.pathname
  const isTmp = pathname === '/template'

  // 账号注销中
  // const info = getUserInfo()
  // if (info.accountStatus === 3 && pathname !== '/my/info ') {
  //   router.push('/my/account')
  // }

  return (
    <Layout className={classNames(styles.container)}>
      <div style={{ height: 0, overflow: 'hidden' }}>
        <LoginModal />
      </div>
      {isTmp ? null : <HeaderComponet />}
      <Main giveawayChannel={giveawayChannel} router={router}>
        {children}
      </Main>
    </Layout>
  )
}
export default PrimaryLayout
